import {Component, contentChildren, effect, inject, input} from '@angular/core';
import {AccordionService} from '@shared/container/accordion/accordion.service';
import {AccordionItemComponent} from '@shared/container/accordion/accordion-item/accordion-item.component';

@Component({
  selector: 'app-accordion',
  providers: [AccordionService],
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.scss'
})
export class AccordionComponent {
  public readonly multiple = input(false);
  public readonly allowUserInteraction = input(true);
  public readonly theme = input<'default' | 'primary' | 'secondary'>('default');
  public readonly border = input(true);
  private readonly items = contentChildren(AccordionItemComponent);

  private readonly service = inject(AccordionService);

  constructor( ) {
    effect(() => {
      this.service.setMultiple(this.multiple());
    });
    effect(() => {
      this.service.setAllowUserInteraction(this.allowUserInteraction());
    });
  }

  public openPrevious(): void {
    this.service.openPrevious();
  }

  public openNext(): void {
    this.service.openNext();
  }
}
